import * as React from 'react';
import { Link } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { Button } from '../../../web/components-v2/Button';

const NewTabLink: React.FC<React.PropsWithChildren<{ to: string }>> = ({ to, children }) => (
	<Button asChild variant='secondary' size='sm'>
		<Link to={to} target='_blank' rel='noopener noreferrer'>
			{children}
		</Link>
	</Button>
);

export const ReviewLink: React.FC<{ aiConversationId?: string }> = ({ aiConversationId }) =>
	aiConversationId ? (
		<NewTabLink to={`/ai-coaching-review?convo=${aiConversationId}`}>Open in review</NewTabLink>
	) : null;

export const CallLogLink: React.FC<{ phoneCallId?: string }> = ({ phoneCallId }) =>
	phoneCallId ? <NewTabLink to={`/call-log/${phoneCallId}`}>Call Log</NewTabLink> : null;

/** Coach Lab is open to Levitate Sales Coffee admins, so only they see the way in. */
const useCanOpenCoachLab = () => {
	const account = useUserSession()?.account;
	return !!account?.isAdmin && !!account?.isLevitateSalesCoffeeAccount;
};

const coachLabFeedbackPath = (aiConversationId: string) =>
	`/settings/coachLab?convo=${encodeURIComponent(aiConversationId)}`;

export const CoachLabFeedbackLink: React.FC<{ aiConversationId?: string }> = ({ aiConversationId }) =>
	useCanOpenCoachLab() && aiConversationId ? (
		<NewTabLink to={coachLabFeedbackPath(aiConversationId)}>Give coach feedback</NewTabLink>
	) : null;
